/* eslint-disable jsx-a11y/anchor-is-valid */

import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
// import { useHistory } from 'react-router-dom';
import PropTypes from 'prop-types';
import { Row } from '@vds/grids';

import { setCookie, setSession, getSession, checkRole, isJointTransactionFlow, getCookie } from '../common/Helpers/index';
import './expressCart.css';
import { processStepRedirection, getRedirectToAPI, getRedirectAPI } from '../../pages/ExpressCart/actions';
import Notification from '../common/Notification/redesign/index';
import logger from '../common/ErrorBoundary/logger_new';
import { CartFaiCashOnlyNoBundleMsg, RoleFailMsg, CollectionsMsg, FraudOrderMsg, NotAccountOwnerMsg, CreditfailMsg } from './helperContent';
import { LANDING, StyledCol } from '../common/styles';

const ExpressCart = (props) => {
  const dispatch = useDispatch();
  // const history = useHistory();
  // don't remove the condition
  if (!window?.vzFlags) {
    window.vzFlags = {};
    window.vzFlags.dispatch = dispatch;
  }
  // window.vzFlags.history = useNavigate();
  // window.vzFlags.history = useHistory();

  const [showLoader, setShowLoader] = useState(false);
  const [isFail, setIsFail] = useState(false);
  const { search } = window.location;
  const params = new URLSearchParams(search);

  useEffect(() => {
    const dawCoupon = getSession('couponToken');
    if (dawCoupon && dawCoupon !== '') {
      props.dawCoupon(dawCoupon);
    }

    if (params.get('abandoned') === 'true') {
      dispatch({ type: 'SET_RESUME_ABANDONED', response: true });
    }
    if (isJointTransactionFlow()) {
      if (search.includes('line=')) {
        const line = params.get('line');
        dispatch({ type: 'JOINT_TRANSACTION_LINE', value: line });
      }
    }
  }, []);

  // const redirect5Ghome = () => {
  //   window.location.href = apiUrls().redirect5Ghome;
  // };

  // const redirectPayBalance = () => {
  //   window.location.href = apiUrls().redirectPayBalance;
  // };

  const onFailHandler = () => {
    if (!isFail) {
      props.invokeTaggingAPI();
      setIsFail(true);
    }
  };

  const pastDueBalAmt = getSession('pastDueBalAmount');
  const {
    onCartFail,
    rolePrepayHome,
    rolePrepayFail,
    newCustBtnText,
    notAccountOwner5G,
    noBundleDetailsFound,
    onAccFailMessage,
    onCashOnly,
    onFraudOrder,
    collections_IND,
    expressState,
  } = props;

  // const { expressCartOnfail } = this.state;
  let cartfail = false;
  const creditfail = params.get('ACCFail') === 'Y';
  // const fiosflow = false;
  const notOwner = params.get('NotOwner') === 'Y';
  const noBundle = params.get('NoBundle') === 'Y';
  const cashOnly = params.get('cashonly') === 'Y';
  const fraudorder = params.get('fraudorder') === 'Y';
  const fraudorderN = params.get('fraudorder') === 'N';
  const collectionsIND = params.get('collections_IND') === 'Y';
  let rolePrepay = params.get('RolePrepay') === 'Y';

  if (params.get('crmResumecart') !== null && params.get('crmResumecart') !== undefined && params.get('crmResumecart') !== '') {
    window.location.href = processStepRedirection(params.get('crmResumecart'));
  }

  if (params.get('ONFail') === 'Y') {
    // || expressCartOnfail === true // TODO
    cartfail = true;
    onFailHandler();
  }

  if (params.get('frmapp') === 'true') {
    getRedirectToAPI();
  }
  if (params.get('frmapp') === 'Y') {
    getRedirectAPI();
  }

  const isAccountMember = checkRole();
  if (isAccountMember) {
    window.history.pushState('', '', '?NotOwner=Y');
  }

  const isPrepayCust = getCookie('role') && getCookie('role').toLowerCase() === 'prepay';
  if (isPrepayCust) {
    rolePrepay = true;
    window.history.pushState('', '', '?RolePrepay=Y');
  }

  if (params.get('expresscart') === 'true' && !isAccountMember) {
    // this.props.pushMessageApiCall();
    if (params.get('resumecart') === 'true') {
      if (!showLoader) {
        props.showLoader();
        setShowLoader(true);
        props.getUpdateCart({ actionType: 'Resume', history: props.history });
        setSession('isResumeOrder', 'Y');
        dispatch({ type: 'CLEAR_COUPON_VALUE' });
      }
    } else if (params.get('resumecart') === 'false' || params.get('signinfromplans') === 'true' || params.get('signinfromCredit')) {
      if (!showLoader) {
        props.showLoader();
        setShowLoader(true);
        props.getUpdateCart({ actionType: 'Restart', history: props.history });
        setSession('isResumeOrder', 'N');
        if (params.get('signinfromplans') === 'true') {
          setSession('signinfromplans', 'Y');
        }
        if (params.get('signinfromCredit') === 'true') {
          const data = {
            messageType: 'INFO',
            message: 'LOGGEDIN FROM CREDITCHECK PAGE',
          };
          logger(data);
          setSession('signinfromCredit', 'Y');
        }
        dispatch({ type: 'CLEAR_COUPON_VALUE' });
      }
    } else if (!showLoader && !isPrepayCust) {
      props.showLoader();
      setShowLoader(true);
      props.getUpdateCart({ history: props.history });
    }
  }
  if (params.get('whwf_redeem') === 'y') {
    if (!showLoader) {
      setSession('WHW', true);
      setShowLoader(true);
      props.postAddToCart({}, 'WHW');
    }
  }

  if (params.get('whwp_redeem') === 'y') {
    if (!showLoader) {
      setShowLoader(true);
      props.updateCartDetails({ actionType: 'WHWP2' });
      // window.location.href = apiUrls().redirectAddons;
    }
  }

  if (params.get('flow') === 'EUP_LTE') {
    if (!showLoader) {
      props.showLoader();
      setShowLoader(true);
      props.getUpdateCartAPI({ history: props.history }, 'EUP_LTE');
    }
  }
  if (params.get('fcc') === 'y') {
    if (!showLoader) {
      setSession('fcc', true);
      setCookie('fcc', true);
      setShowLoader(true);
      props.getUpdateCart({ history: props.history });
    }
  }

  if (search.includes('address')) {
    const searchValue = params.get('address');
    if (params.get('isVendorFlow') === 'Y') {
      setCookie('isvendorFLow', true);
    }
    if (!showLoader) {
      props.showLoader();
      setShowLoader(true);
      props.partnerCheckAvlAPI(searchValue);
    }
  }

  if (expressState && expressState.expressCart && expressState.expressCart.updateCartFail && !isPrepayCust) {
    cartfail = true;
    onFailHandler();

    window.history.pushState('', '', '?ONFail=Y');
  }
  const notificationProps = {
    renderIf: false,
    title: '',
    type: 'warning',
    serviceInfo: '',
    subtitle: '',
  };
  if (props.showCartApiError) {
    notificationProps.renderIf = true;
    notificationProps.title = props?.notifyErrorMsg;
  }

  return (
    <LANDING>
      <div className="content">
        <div className="mainContainer">
          <Row>
            <StyledCol top="12px" xs={12} lg={12} sm={12}>
              <Notification {...notificationProps} />
            </StyledCol>
          </Row>

          <Row>
            <StyledCol top="12px" xs={12} lg={12} sm={12}>
              {cartfail && !rolePrepay && (
                <div className="alignCenter">
                  <CartFaiCashOnlyNoBundleMsg message={onCartFail} defaultMsg="Something went wrong. Please try again later." />
                </div>
              )}

              {rolePrepay && (
                <div className="alignLeft">
                  <RoleFailMsg
                    title={rolePrepayHome}
                    message={rolePrepayFail}
                    newCustBtnText={newCustBtnText}
                    defaultMsg="Sorry, home internet isn't currently available on your existing account."
                  />
                </div>
              )}

              {collectionsIND && (
                <div className="alignCenter">
                  <CollectionsMsg collections_IND={collections_IND} />
                </div>
              )}
              {creditfail && (
                <div aria-live="assertive" role="alertdialog">
                  <CreditfailMsg accFailMessage={onAccFailMessage} pastDueBalAmt={pastDueBalAmt} />
                </div>
              )}
              {cashOnly && (
                <div className="alignCenter">
                  <CartFaiCashOnlyNoBundleMsg
                    message={onCashOnly}
                    defaultMsg="Please visit a verizon wireless retail location to complete your purchase."
                  />
                </div>
              )}
              {fraudorder && (
                <div className="alignCenter">
                  <FraudOrderMsg
                    fraudContent={onFraudOrder}
                    defaultMsg="Account maintenance has been restricted at this time. The account owner is requested to contact Verizon Customer Protection at: 888-483-7200
        in order to restore full access."
                  />
                </div>
              )}
              {fraudorderN && (
                <div className="alignCenter">
                  <FraudOrderMsg defaultMsg="Account maintenance has been temporarily restricted at the request of the account owner" />
                </div>
              )}

              {notOwner && (
                <div className="alignCenter">
                  <div className="notOwners" aria-live="assertive" role="alertdialog">
                    <NotAccountOwnerMsg notAccountOwner={notAccountOwner5G}> </NotAccountOwnerMsg>
                  </div>
                </div>
              )}

              {noBundle && (
                <div className="alignCenter">
                  <CartFaiCashOnlyNoBundleMsg
                    message={noBundleDetailsFound}
                    defaultMsg="Sorry, product is not currently available to order at this location. Please check back soon."
                  />
                </div>
              )}
            </StyledCol>
          </Row>
        </div>
        <div className="orderContainer" />
      </div>
    </LANDING>
  );
};

ExpressCart.propTypes = {
  showLoader: PropTypes.func,
  getUpdateCart: PropTypes.func,
  getUpdateCartAPI: PropTypes.func,
  getReviewOrder: PropTypes.func,
  postAddToCart: PropTypes.func,
  updateCartDetails: PropTypes.func,
  partnerCheckAvlAPI: PropTypes.func,
  onCartFail: PropTypes.string,
  rolePrepayFail: PropTypes.string,
  rolePrepayHome: PropTypes.string,
  newCustBtnText: PropTypes.string,
  notAccountOwner5G: PropTypes.string,
  noBundleDetailsFound: PropTypes.string,
  onAccFailMessage: PropTypes.string,
  onCashOnly: PropTypes.string,
  collections_IND: PropTypes.string,
  onFraudOrder: PropTypes.string,
  invokeTaggingAPI: PropTypes.func,
  dawCoupon: PropTypes.func,
  expressState: PropTypes.any,
  showCartApiError: PropTypes.any,
  notifyErrorMsg: PropTypes.string,
  history: PropTypes.object,
};

export default ExpressCart;
